import React, { Component, ErrorInfo, ReactNode } from 'react';

import SomeThingWentWrong from '@/pages/error-page/500-page/SomeThingWentWrong';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    const { fallback = <SomeThingWentWrong /> } = this.props;
    if (this.state.hasError) {
      return <>{fallback}</>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
